import Vue from 'vue'
import { Toast, Loading, NavBar, Icon, Area, Dialog, List, Checkbox, Image, CheckboxGroup, Switch, Search, Stepper, Panel, ActionSheet,DatetimePicker } from 'vant'

Vue.use(Toast).use(Loading).use(NavBar).use(Icon).use(Area).use(Dialog).use(List).use(Checkbox).use(Image).use(CheckboxGroup).use(Switch).use(Search).use(Stepper).use(Panel).use(ActionSheet)
.use(DatetimePicker)